module.exports = __webpack_public_path__ + "img/11.9d73d0e9.png";